import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Campaign, Contact, Template } from '../../models/api.models';
import { CampaignsService } from '../../services/campaigns.service';
import { ContactsService } from '../../services/contacts.service';
import { TemplatesService } from '../../services/templates.service';

@Component({
  selector: 'app-campaigns-page',
  templateUrl: './campaigns.page.html',
  styleUrls: ['./campaigns.page.scss'],
})
export class CampaignsPage implements OnInit {
  campaigns: Campaign[] = [];
  contacts: Contact[] = [];
  templates: Template[] = [];
  readonly form: UntypedFormGroup;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly campaignsService: CampaignsService,
    private readonly contactsService: ContactsService,
    private readonly templatesService: TemplatesService
  ) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      template_id: [0, [Validators.required]],
      scheduled_at: [''],
      contact_ids: [[] as number[]],
      variable_defaults: ['offer=20% OFF, city=Mumbai'],
    });
  }

  ngOnInit(): void {
    this.loadCampaigns();
    this.loadContacts();
    this.loadTemplates();
  }

  create(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    if (!value.template_id || !value.contact_ids.length) {
      return;
    }

    const payload: Campaign = {
      name: value.name,
      template_id: value.template_id,
      scheduled_at: value.scheduled_at || null,
      contact_ids: value.contact_ids,
      variable_defaults: this.parseVariables(value.variable_defaults),
    };

    this.campaignsService.create(payload).subscribe({
      next: () => {
        this.loadCampaigns();
      },
    });
  }

  dispatch(campaign: Campaign): void {
    if (!campaign.id) {
      return;
    }

    this.campaignsService.dispatch(campaign.id).subscribe();
  }

  private parseVariables(input: string): Record<string, string> {
    return String(input)
      .split(',')
      .map((entry: string) => entry.trim())
      .filter(Boolean)
      .reduce<Record<string, string>>((carry, entry: string) => {
        const [key, ...rest] = entry.split('=');
        if (key && rest.length) {
          carry[key.trim()] = rest.join('=').trim();
        }
        return carry;
      }, {});
  }

  private loadCampaigns(): void {
    this.campaignsService.list().subscribe({
      next: (response) => {
        this.campaigns = response;
      },
      error: () => {
        this.campaigns = [
          {
            id: 1,
            name: 'April Launch Push',
            template_id: 1,
            scheduled_at: '2026-04-04T18:00:00+05:30',
            status: 'draft',
            contact_ids: [1, 2],
            variable_defaults: { offer: '20% OFF' },
          },
        ];
      },
    });
  }

  private loadContacts(): void {
    this.contactsService.list().subscribe({
      next: (response) => {
        this.contacts = response;
      },
      error: () => {
        this.contacts = [
          { id: 1, name: 'Anika Fashion', phone_number: '+919876543210', tags: ['vip'], status: 'active' },
          { id: 2, name: 'Suresh Electronics', phone_number: '+919123456789', tags: ['b2b'], status: 'active' },
        ];
      },
    });
  }

  private loadTemplates(): void {
    this.templatesService.list().subscribe({
      next: (response) => {
        this.templates = response;
      },
      error: () => {
        this.templates = [
          {
            id: 1,
            name: 'promo_launch_v1',
            category: 'marketing',
            language: 'en',
            body: 'Hi {{1}}, your {{2}} is live today.',
            variables: ['customer_name', 'offer'],
            status: 'approved',
          },
        ];
      },
    });
  }
}
